import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de59257c360032/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de59257c360032/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de59257c360032/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de59257c360032/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de59257c360032/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/app/[locale]/branchen/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/node_modules/next/dist/client/link.js");
